<umss-input
  placeholder="Search..."
  prefixIconName="phosphorMagnifyingGlass"
  [suffixIconName]="searchFormControl.value ? 'phosphorX' : ''"
  [placeholder]="placeholder() || 'Search'"
  [formControl]="searchFormControl"
  (suffixIconClick)="onClear()"
>
</umss-input>
